import { gql } from '@apollo/client/core'

export const LOGIN_USER = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(input: { email: $email, password: $password }) {
      user {
        id
        email
      }
      errors
    }
  }
`

export const CREATE_USER = gql`
  mutation CreateUser($email: String!, $password: String!, $registration: String, $job: String!, $access: String!, $firstName: String!, $lastName: String!) {
    createUser(input: {
      email: $email,
      password: $password,
      registrationNumber: $registration,
      jobTitle: $job,
      accessLevel: $access
      firstName: $firstName
      lastName: $lastName
    }) {
      user { id email accessLevel }
      errors
    }
  }
`;

export const CREATE_CLINIC = gql`
  mutation CreateClinic($name: String!, $location: String!) {
    createClinic(input: {
      name: $name,
      location: $location,
    }) {
      clinic { id name location }
      errors
    }
  }
`;

export const CREATE_CONSULT = gql`
  mutation CreateConsult($input: CreateConsultInput!) {
    createConsult(input: $input) {
      id
      consultType
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_CONSULT = gql`
  mutation UpdateConsult($input: UpdateConsultInput!) {
    updateConsult(input: $input) {
      id
      consultType
      createdAt
      updatedAt
    }
  }
`

export const CREATE_PATIENT = gql`
  mutation CreatePatient($input: CreatePatientInput!) {
    createPatient(input: $input) {
      id
      createdAt
      updatedAt
    }
  }
`

export const CREATE_CONSULT_NOTE = gql`
  mutation CreateConsultNote($input: CreateConsultNoteInput!) {
    createConsultNote(input: $input) {
      id
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_PATIENT = gql`
  mutation UpdatePatient($input: UpdatePatientInput!) {
    updatePatient(input: $input){
      id
      firstName
      middleNames
      lastName
      gender
      dateOfBirth
      idNumber
      passportNumber
      employeeNumber
      allergies
      surgeries
      chronics
      phoneNumber
      alternatePhone
      email
      addressLine1
      addressLine2
      city
      stateOrProvince
      postalCode
      country
      emergencyContactName
      emergencyContactPhone
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($input: UpdatePasswordInput!) {
    updatePassword(input: $input) {
      success
    }
  }
`

export const VERIFY_PASSWORD = gql`
  mutation VerifyPassword($password: String!) {
    verifyPassword(input: {password: $password}) {
      success
    }
  }
`